//#region types
import { FormEnums } from "models/enums";
import { EditableFormInnerProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import ReadOnlyFormInner from "./readOnlyFormInner";
import ReadOnlyRemovableFormInner from "./readOnlyRemovableFormInner";
import EditableFormInnerWizard from "./editableFormInnerWizard";
import EditableFormInnerExpandable from "./editableFormInnerExpandable";
import EditableFormInnerFieldGroupSection from "./editableFormInnerFieldGroupSection";
import EditableFormInnerTab from "./editableFormInnerTab";
import EditableFormInnerFields from "./editableFormInnerFields";
import EditableFormDialogWizard from "./editableFormDialogWizard";
//#endregion

function GenericFormInner<T extends Record<string, any>>(props: EditableFormInnerProps<T>) {
  const getFieldComponent = () => {
    if (props.isReadOnly) return ReadOnlyFormInner;
    else if (props.asRemovableValues) return ReadOnlyRemovableFormInner;
    else if (Array.isArray(props.fields)) {
      if (props.fields.length === 0) return undefined;
      switch (props.fields[0].type) {
        case FormEnums.FormSectionType.WIZARDTAB:
          return EditableFormInnerWizard;
        case FormEnums.FormSectionType.EXPANDABLESECTION:
          return EditableFormInnerExpandable;
        case FormEnums.FormSectionType.FIELDGROUPSECTION:
          return EditableFormInnerFieldGroupSection;
        case FormEnums.FormSectionType.SIMPLETAB:
          return EditableFormInnerTab;
        case FormEnums.FormSectionType.DIALOGWIZARD:
          return EditableFormDialogWizard;
        default:
          return EditableFormInnerFields;
      }
    } else {
      return EditableFormInnerFields;
    }
  };

  const FieldComponent = props.fields ? getFieldComponent() : undefined;

  return FieldComponent ? <FieldComponent<T> {...props} /> : <></>;
}

export default GenericFormInner;
